import React from 'react';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { useTranslationContext } from '../../context';
var UnMemoizedSafeAnchor = function (props) {
    var children = props.children, className = props.className, download = props.download, href = props.href, rel = props.rel, target = props.target;
    var t = useTranslationContext('SafeAnchor').t;
    if (!href)
        return null;
    var sanitized = sanitizeUrl(href);
    return (React.createElement("a", { "aria-label": t('aria/Attachment'), className: className, download: download, href: sanitized, rel: rel, target: target }, children));
};
export var SafeAnchor = React.memo(UnMemoizedSafeAnchor);
